export const createMediaStreamTrackGenerator = init => {
    const generator = new MediaStreamTrackGenerator(init);
    return generator;
};
//# sourceMappingURL=generator.js.map